export const ALLOWED_FILES_ARRAY = [
  '.doc',
  '.docx',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf',
]
export const ALLOWED_FILES = ALLOWED_FILES_ARRAY.join(',')

export const RESUME_MAX_SIZE = 10_000_000 // 10 MB
export const IMAGE_FILE_REGEX = /image\/(jpe?g|png|gif)/
